<template>
  <custom-dialog width="680px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_group_dialog.suo_shu_ying_yong')" prop="appId">
              <el-select v-model="form.appId" disabled :placeholder="$t('Common.com_please_select')">
                <el-option v-for="item in model.data.appList" :key="item.appId" :label="item.appName" :value="item.appId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_dictionary_group_dialog.shang_ji_fen_zu')" prop="parentId">
              <custom-select
                v-model="form.parentId"
                :placeholder="$t('Common.com_please_select')"
                :props="{ label: 'name', value: 'value', checkStrictly: true }"
                type="tree"
                url="DictGroupTree"
                :show-all-levels="false"
                :params="{ appId: model.data.appId, groupId: groupId }"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_dictionary_group_dialog.fen_zu_ji_bie')" prop="groupLevel">
              <el-select v-model="form.groupLevel" :placeholder="$t('Common.com_please_select')">
                <el-option v-for="item in model.data.groupLevels" :key="item.id" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_dictionary_group_dialog.fen_zu_ming_cheng')" prop="groupName">
              <el-input v-model="form.groupName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_dictionary_group_dialog.fen_zu_dai_ma')" prop="groupCode">
              <el-input v-model="form.groupCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('base_dictionary_group_dialog.zi_dian_jie_gou')" prop="dicType">
              <el-select v-model="form.dicType" :placeholder="$t('Common.com_please_select')">
                <el-option v-for="item in model.data.groupTypes" :key="item.id" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_dictionary_group_dialog.fzdyydm')" prop="langGroupName">
              <el-input v-model="form.langGroupName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_group_dialog.fen_zu_miao_shu')" prop="groupDesc">
              <el-input type="textarea" v-model="form.groupDesc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveGroup">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      groupId: '',
      appTree: [],
      form: {
        appId: '',
        groupId: '',
        dicType: '',
        groupCode: '',
        groupDesc: '',
        groupLevel: '',
        groupName: '',
        langGroupName: '',
        parentId: null,
      },
    };
  },
  computed: {
    rules() {
      return {
        appId: [
          {
            required: true,
            message: this.$t('base_dictionary_group_dialog.ssyyidbt'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ],
        dicType: [
          {
            required: true,
            message: this.$t('base_dictionary_group_dialog.qxzzdjg'),
          },
          { max: 10, message: this.$t('Common.com_rules_length_max', [10]), },
        ],
        groupCode: [
          {
            required: true,
            message: this.$t('base_dictionary_group_dialog.qtxfzdm'),
          },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        groupLevel: [
          {
            required: true,
            message: this.$t('base_dictionary_group_dialog.qxzfzjb'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ],
        groupName: [
          {
            required: true,
            message: this.$t('base_dictionary_group_dialog.qtxfzmc'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        langGroupName: [
          {
            required: true,
            message: this.$t('base_dictionary_group_dialog.qtxfzdyydm'),
          },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        groupDesc: { max: 500, message: this.$t('Common.com_rules_length_max', [500]), },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.form.appId = this.model.data.appId; // 所属应用
      if (this.model.type === 'add') {
        this.form.parentId = this.model.data.group.groupId;
        this.appTree = this.model.data.appTree;
      }
      if (this.model.type === 'edit') {
        this.form.parentId = this.model.data.group.parentId === '0' ? null : this.model.data.group.parentId;
        this.groupId = this.model.data.group.groupId;
        this.form.dicType = `${this.model.data.group.dicType}`;
        this.form.groupCode = this.model.data.group.groupCode;
        this.form.groupDesc = this.model.data.group.groupDesc;
        this.form.groupLevel = `${this.model.data.group.groupLevel}`;
        this.form.groupName = this.model.data.group.groupName;
        this.form.langGroupName = this.model.data.group.langGroupName;
        this.getAppTree();
      }
    },
    // 下拉树配置
    normalizer(node) {
      return {
        id: node.value,
        label: node.name,
      };
    },
    // 获取平台树
    getAppTree: function () {
      this.appTree = [];
      this.$getJSON(apis.DictGroupTree, {
        appId: this.model.data.appId,
        groupId: this.groupId,
      }).then((res) => {
        this.appTree = res.data || [];
      });
    },
    // 确认保存分组
    saveGroup: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddGroup();
        }
        if (this.model.type === 'edit') {
          this.saveEditGroup();
        }
      });
    },
    getParentId(ret) {
      if (Array.isArray(ret.parentId)) {
        const len = Math.max(0, ret.parentId.length - 1);
        return ret.parentId[len];
      }
      return ret.parentId;
    },
    getReqData() {
      const ret = {
        ...this.form,
      };
      ret.parentId = this.getParentId(ret);
      return ret;
    },
    // 保存新增分组
    saveAddGroup: function () {
      this.$postJSON(apis.DictGroupAdd, this.getReqData()).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑分组
    saveEditGroup: function () {
      this.form.groupId = this.groupId;
      this.$postJSON(apis.DictGroupUpdate, this.getReqData()).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
